import Vue from 'vue';
import App from './App.vue';
import router from '@/router/index';
import store from "@/store/index";
import vuetify from './plugins/vuetify'
import axios from 'axios';
import {SERVER_HOST_QR} from '@/config.ts'
import './plugins/i18n'

import i18n from "./helpers/i18n"

Vue.config.productionTip = false;


/**
 * Базовый URL сервера
 */
axios.defaults.baseURL = SERVER_HOST_QR
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.get['Content-Type'] = 'application/json'



new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
